export const isCurrentPage = () => {
    const currentPath = window.location.pathname
    const locale = document.documentElement.lang || 'ru'

    const productElement = document.querySelector('.vue-data-product')
    const currentProduct = productElement
        ? JSON.parse(productElement.textContent)
        : null

    const collectionsElement = document.querySelector('.vue-data-collections')
    const currentCollections = collectionsElement
        ? JSON.parse(collectionsElement.textContent)
        : null

    const collectionElement = document.querySelector('.vue-data-collection')
    const currentCollection = collectionElement
        ? JSON.parse(collectionElement.textContent)
        : null

    return (url) => {
        if (!url) return false

        const path = new URL(url, window.location.origin).pathname

        if (path === currentPath) {
            return true
        }

        const categoryUrl = currentProduct?.category?.urls?.[locale]

        if (categoryUrl === path) {
            return true
        }

        const collectionsUrl = currentCollections?.urls?.[locale]

        if (collectionsUrl === path) {
            return true
        }

        const collectionUrl = currentCollection?.collection?.urls?.[locale]

        if (collectionUrl === path) {
            return true
        }

        return false
    }
}